import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import api from "../api";

const Profile = () => {
  const [responsavel, setResponsavel] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [userId, setUserId] = useState(null); // Inicialmente null para evitar requisições sem ID

  const [erroDados, setErroDados] = useState("");
  const [sucessoDados, setSucessoDados] = useState("");
  const [erroSenha, setErroSenha] = useState("");
  const [sucessoSenha, setSucessoSenha] = useState("");
  const [loadingDados, setLoadingDados] = useState(false);
  const [loadingSenha, setLoadingSenha] = useState(false);

  useEffect(() => {
    // Buscar os dados do próprio usuário
    const fetchUserData = async () => {
      try {
        const response = await api.get("/usuarios/me");
        const { id, responsavel, email, telefone } = response.data;
        console.log(response.data);
        setUserId(id); // Define o ID do usuário
        setResponsavel(responsavel || "");
        setEmail(email || "");
        setTelefone(telefone || "");
      } catch (error) {
        setErroDados("Erro ao carregar dados do usuário.");
      }
    };

    fetchUserData();
  }, []);

  const handlePhoneChange = (value) => {
    // Remove caracteres não numéricos e aplica a máscara (99) 999999999
    const onlyNumbers = value.replace(/\D/g, "");
    const formattedPhone = onlyNumbers
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .slice(0, 14);
    setTelefone(formattedPhone);
  };

  const handleUpdate = async () => {
    if (!userId) {
      setErroDados("ID do usuário não encontrado. Recarregue a página.");
      return;
    }

    if (!email || !telefone) {
      setErroDados("Os campos Email e Telefone são obrigatórios.");
      return;
    }

    setLoadingDados(true);
    setErroDados("");
    setSucessoDados("");

    try {
      await api.put(`/usuarios/${userId}`, { responsavel, email, telefone });
      setSucessoDados("Dados atualizados com sucesso.");
    } catch (error) {
      setErroDados("Erro ao atualizar os dados.");
    } finally {
      setLoadingDados(false);
    }
  };

  const handleChangePassword = async () => {
    if (!userId) {
      setErroSenha("ID do usuário não encontrado. Recarregue a página.");
      return;
    }

    if (!senhaAtual || !novaSenha) {
      setErroSenha("Os campos Senha Atual e Nova Senha são obrigatórios.");
      return;
    }

    setLoadingSenha(true);
    setErroSenha("");
    setSucessoSenha("");

    try {
      await api.put(`/usuarios/${userId}/senha`, { senhaAtual, novaSenha });
      setSucessoSenha("Senha alterada com sucesso.");
      setSenhaAtual("");
      setNovaSenha("");
    } catch (error) {
      setErroSenha("Erro ao alterar a senha.");
    } finally {
      setLoadingSenha(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: "0 auto", padding: 4 }}>
      <Typography variant="h4" mb={2}>
        Meu Perfil
      </Typography>

      {/* Atualizar Dados */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">Atualizar Dados</Typography>
        {erroDados && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {erroDados}
          </Alert>
        )}
        {sucessoDados && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {sucessoDados}
          </Alert>
        )}
        <TextField
          label="Responsável"
          value={responsavel}
          onChange={(e) => setResponsavel(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Telefone"
          value={telefone}
          onChange={(e) => handlePhoneChange(e.target.value)}
          fullWidth
          margin="normal"
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          disabled={loadingDados}
          startIcon={loadingDados && <CircularProgress size={20} />}
        >
          {loadingDados ? "Atualizando..." : "Atualizar Dados"}
        </Button>
      </Box>

      {/* Alterar Senha */}
      <Box>
        <Typography variant="h6">Alterar Senha</Typography>
        {erroSenha && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {erroSenha}
          </Alert>
        )}
        {sucessoSenha && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {sucessoSenha}
          </Alert>
        )}
        <TextField
          label="Senha Atual"
          type="password"
          value={senhaAtual}
          onChange={(e) => setSenhaAtual(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Nova Senha"
          type="password"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
          fullWidth
          margin="normal"
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={handleChangePassword}
          disabled={loadingSenha}
          startIcon={loadingSenha && <CircularProgress size={20} />}
        >
          {loadingSenha ? "Alterando..." : "Alterar Senha"}
        </Button>
      </Box>
    </Box>
  );
};

export default Profile;
